import {modelHydrator} from "./_modelHydrator";
import {size} from "../size";
import {sizeResultType} from "../../types/Api/SizeResultType";
import {bodyAreaHydrator} from "./bodyAreaHydrator";

export const sizeHydrator = {
  hydrate: (size: sizeResultType): size => {
    return Object.assign({
      sizeId: size.sizeId,
      label: size.label,
      order: size.order,
      bodyArea: size.bodyArea.map((bodyArea) => bodyAreaHydrator.hydrate(bodyArea)),
      stock: size.stock,
      equipmentSizeId: size.equipmentSizeId,
    }, modelHydrator.hydrate(size))
  }
}